import { Component, OnInit } from '@angular/core';
import { FileDownloadService } from 'src/app/shared/file-download/file-download.service';

const METRICS_DOWNLOAD_URI = 'report/metrics-email-link/download';

@Component({
  selector: 'report-metrics',
  templateUrl: './report-metrics.component.html',
})
export class ReportMetricsComponent implements OnInit {


  constructor(
    private readonly download: FileDownloadService,
  ) { }

  ngOnInit() {
    const date = new Date();
    const filename = `rptMetrics_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`;
    this.download.downloadFile(METRICS_DOWNLOAD_URI, filename).subscribe();
  }

}
